// Single source of truth shared between the Builder input schema and the AppModel mapper.
export const DEFAULT_STEPPER_PROGRESS_LABEL = "Progress";
